import { getClient } from './client';

import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from './apiDictionary';
import {
  ClinicalTrialReport,
  ClinicalTrialReportFromApi,
  ClinicalTrialReportsFetchRequestAction,
  ClinicalTrialReportUpdateStatusRequestAction,
  ClinicalTrialReportUrlFetchRequestAction,
  ClinicalTrialReportUrlFetchSuccessAction,
} from '@restore/clinicalTrialReports/clinicalTrialReports.types';
import { PaginatedResponse } from '@dynamika-shared/types/general';
import { fetchReportsMock } from '@api/mocks/clinicalTrialReports';

export const fetchReports = async ({
  clinicalTrialId,
  sort,
  size,
  page,
  search,
  reviewStatus,
}: ClinicalTrialReportsFetchRequestAction['payload']) => {
  fetchReportsMock(clinicalTrialId);
  return getClient(API_URL.reports).get<PaginatedResponse<ClinicalTrialReport>>(
    prepareUrl(API_URL.reports, [clinicalTrialId]),
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      params: {
        size,
        page: page - 1,
        search,
        reviewStatus,
        ...(sort && { sort }),
      },
    }
  );
};

export const fetchReportUrl = async ({
  clinicalTrialId,
  reportId,
}: ClinicalTrialReportUrlFetchRequestAction['payload']) => {
  return getClient(API_URL.reportsUrl).get<
    ClinicalTrialReportUrlFetchSuccessAction['payload']
  >(prepareUrl(API_URL.reportsUrl, [reportId]), {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
  });
};

export const changeReportStatus = async ({
  clinicalTrialId,
  reportId,
  status,
  notification,
}: ClinicalTrialReportUpdateStatusRequestAction['payload']) => {
  return getClient(API_URL.reportsUrl).put<ClinicalTrialReportFromApi>(
    prepareUrl(API_URL.reportsStatus, [reportId]),
    {
      status,
      ...(typeof notification !== 'undefined' ? { notification } : {}),
    },
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
    }
  );
};
